import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setShowMenu(!showMenu);
  const closeMenu = () => setShowMenu(false);

  const menuItems = [
    { name: 'Home', to: 'hero' },
    { name: 'About', to: 'about' },
    { name: 'Services', to: 'services' },
    { name: 'Properties', to: 'properties' },
    { name: 'Testimonials', to: 'testimonials' },
    { name: 'Contact', to: 'contact' }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <div className="logo">
            <h2>Jeevika Property</h2>
            <p>Consultant</p>
          </div>

          <ul className={`nav-menu ${showMenu ? 'active' : ''}`}>
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link to={item.to} smooth={true} duration={500} offset={-70} onClick={closeMenu}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          <div className="navbar-cta">
            <a href="tel:+919876543210" className="phone-btn">
              <FaPhone /> Call Now
            </a>
          </div>

          <div className="mobile-menu-icon" onClick={toggleMenu}>
            {showMenu ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;